export default "__VITE_ASSET__DRK1FcMr__"